import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function ExamResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [isPassed, setIsPassed] = useState(false);


  const [shikakuData, setShikakuData] = useState<any>(null);

  useEffect(() => {
    // Get result from navigation state
    const state = location.state as { result: any; questions: any[]; userId: string } | null;

    if (state && state.result) {
      const { totalScore } = state.result;
      setScore(totalScore);
      setIsPassed(totalScore >= 70);


      // Fetch Shikaku Data for comments
      const fetchShikakuData = async () => {
        if (state.result.ShikakuRef) {
          try {
            // Import getDoc and db if not already imported
            const { getDoc } = await import('firebase/firestore');


            const shikakuDoc = await getDoc(state.result.ShikakuRef);
            if (shikakuDoc.exists()) {
              setShikakuData(shikakuDoc.data());
            }
          } catch (err) {
            console.error("Error fetching shikaku data:", err);
          }
        }
      };
      fetchShikakuData();

    } else {
      // Fallback or redirect if no state
      // For now, just redirect to home if no result
      // navigate('/home');
    }
  }, [location, navigate]);

  const getScoreComment = () => {
    if (!shikakuData) return null;

    if (score === 100) return shikakuData.Lv100;
    if (score >= 95) return shikakuData.Lv95;
    if (score >= 90) return shikakuData.Lv90;
    if (score >= 80) return shikakuData.Lv80;
    if (score >= 70) return shikakuData.Lv70;
    return shikakuData.Lv1;
  };

  const comment = getScoreComment();

  const handleRetry = () => {
    navigate('/exam');
  };

  const handleGoHome = () => {
    navigate('/home');
  };

  // ... existing code ...

  return (
    <div className="min-h-screen bg-[#F5F5F5] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-3xl shadow-sm p-8">
          {/* ... existing header code ... */}
          <div className="text-center mb-8">
            {isPassed ? (
              <>
                <div className="inline-flex items-center justify-center w-24 h-24 bg-orange-100 rounded-full mb-6">
                  <i className="ri-trophy-line text-orange-500 text-5xl"></i>
                </div>
                <h1 className="text-2xl font-bold text-gray-800 mb-2">合格おめでとうございます！</h1>
                <p className="text-gray-500 text-sm">素晴らしい結果です</p>
              </>
            ) : (
              <>
                <div className="inline-flex items-center justify-center w-24 h-24 bg-gray-100 rounded-full mb-6">
                  <i className="ri-emotion-sad-line text-gray-400 text-5xl"></i>
                </div>
                <h1 className="text-2xl font-bold text-gray-800 mb-2">もう少しでした</h1>
                <p className="text-gray-500 text-sm">次回は合格できるよう頑張りましょう</p>
              </>
            )}
          </div>

          <div className={`rounded-2xl p-6 mb-8 border ${isPassed
            ? 'bg-orange-50 border-orange-200'
            : 'bg-gray-50 border-gray-200'
            }`}>
            <div className="text-center">
              <p className="text-gray-600 mb-2 text-sm">あなたの得点</p>
              <div className="text-6xl font-bold mb-2 text-gray-800">
                {score}
                <span className="text-2xl text-gray-400 ml-1">点</span>
              </div>
              <div className="flex items-center justify-center gap-2 text-gray-500 text-xs">
                <i className="ri-information-line"></i>
                <span>合格基準: 70点以上</span>
              </div>
            </div>
          </div>

          {/* Score comments based on level */}
          {comment && (
            <div className="mb-8 p-6 bg-gray-50 border border-gray-200 rounded-xl">
              <h3 className="text-gray-800 font-bold mb-2 flex items-center gap-2 text-sm">
                <i className="ri-message-3-line"></i>
                総評
              </h3>
              <p className="text-gray-600 whitespace-pre-wrap leading-relaxed text-sm text-left">
                {comment}
              </p>
            </div>
          )}

          <div className="space-y-3">
            {isPassed ? (
              <>
                <button
                  onClick={handleGoHome}
                  className="w-full bg-[#F4B183] text-white py-4 rounded-xl font-bold hover:bg-[#E5A072] transition-colors shadow-sm flex items-center justify-center gap-2"
                >
                  <i className="ri-home-heart-line"></i>
                  ホームに戻る
                </button>
                <button
                  onClick={handleRetry}
                  className="w-full bg-white text-gray-600 py-4 rounded-xl font-bold hover:bg-gray-50 transition-colors border border-gray-200 flex items-center justify-center gap-2"
                >
                  <i className="ri-refresh-line"></i>
                  もう一度受験する
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={handleRetry}
                  className="w-full bg-[#F4B183] text-white py-4 rounded-xl font-bold hover:bg-[#E5A072] transition-colors shadow-sm flex items-center justify-center gap-2"
                >
                  <i className="ri-refresh-line"></i>
                  再チャレンジする
                </button>
                <button
                  onClick={handleGoHome}
                  className="w-full bg-white text-gray-600 py-4 rounded-xl font-bold hover:bg-gray-50 transition-colors border border-gray-200 flex items-center justify-center gap-2"
                >
                  <i className="ri-home-heart-line"></i>
                  ホームに戻る
                </button>
              </>
            )}
          </div>

          {isPassed && (
            <div className="mt-8 bg-orange-50 rounded-2xl p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-send-line text-orange-500 text-sm"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 mb-1 text-sm">合格証明書について</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    合格証明書は、登録されたメールアドレスに送信されます。数日以内にご確認ください。
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
